import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable, of } from 'rxjs';
import type { SuggestionsMapperService } from './base/suggestions-mapper.service';
import { SuggestionsService } from './base/suggestions.service';
import type { NoMultiLangCompanyCreateRequest } from './suggestion-iterfaces';

@Injectable()
export class NoopSuggestionsService extends SuggestionsService<unknown, unknown> {
  settings = {
    key: null,
    minLength: null,
  };

  constructor(mapper: SuggestionsMapperService<unknown, unknown>, httpClient: HttpClient, key: string) {
    super(mapper, httpClient, key);
  }

  getCompany(_id: string): Observable<NoMultiLangCompanyCreateRequest | null> {
    return of(null);
  }
}
